import DataMap from 'assets/components/dataMap/DataMap';
import ErrorWrapper from 'assets/components/inputs/wrappers/ErrorWrapper';
import ThemeTableSimple from 'assets/components/table/themes/Theme.Table.Simple';
import { getLocales } from 'assets/locales/Locale';
import { date, defaultDateTimeFormat, defaultServerDateTimeFormat } from 'assets/utils/data/Date';
import { combineStrings } from 'assets/utils/data/String';
import { useClaimEdit } from '../ClaimEdit.Hooks';

export default function ClaimEditOwnershipLogs() {
  const { claim, product, claimOwnershipLogListApi } = useClaimEdit();
  const { lang } = getLocales();

  const ownershipLogs = claimOwnershipLogListApi?.payload?.data ?? [];

  return (
    <>
      <h2 id="ownershipLogs" style={{ marginTop: 0 }}>
        {lang.ownershipLogs}
      </h2>
      {!ownershipLogs?.length && <ErrorWrapper children={lang.noInfo} />}

      {!!ownershipLogs?.length && (
        <table className={ThemeTableSimple}>
          <thead>
            <tr>
              <th>{lang.claim}</th>
              <th>{lang.owner}</th>
              <th>{lang.changedBy ?? lang.createdBy}</th>
              <th>{lang.createdAt}</th>
            </tr>
          </thead>
          <tbody>
            {!ownershipLogs?.length && (
              <tr>
                <td colSpan={4}>{lang.noInfo}</td>
              </tr>
            )}

            <DataMap
              data={ownershipLogs}
              render={({ data: log }) => (
                <tr key={log?.id}>
                  <td>
                    <b>{combineStrings('-', product?.category?.code, claim?.id?.toString())}</b>
                    <br />
                    {product?.name ?? lang.unknownProduct}
                  </td>
                  <td>{log?.owner?.fullName ?? 'N / A'}</td>
                  <td>{log?.createdBy?.fullName ?? 'N / A'}</td>
                  <td>{date(log?.createdAtUtc, defaultServerDateTimeFormat).format(defaultDateTimeFormat)}</td>
                </tr>
              )}
            />
          </tbody>
        </table>
      )}
    </>
  );
}
